import { IconX } from "@tabler/icons-react";
import { Badge, Button, Group, Td, Text, Tr } from "@/components/ui";
import type { Area, OrganizacionAdmin, UsuarioAdmin } from "@/lib/types";
import { PanelEdicionUsuario } from "./PanelEdicionUsuario";

/**
 * Fila de usuario para la tabla desktop · 7 columnas + expansión a una
 * fila con el panel de edición. La fila expandida ocupa `colSpan={7}`.
 */
export function UsuarioRow({
  u,
  expandida,
  onToggle,
  todasAreas,
  todasOrganizaciones,
}: {
  u: UsuarioAdmin;
  expandida: boolean;
  onToggle: () => void;
  todasAreas: Area[];
  todasOrganizaciones: OrganizacionAdmin[];
}) {
  return (
    <>
      <Tr className="align-top">
        <Td>
          <Text size="xs" className="font-mono">
            {u.email}
          </Text>
        </Td>
        <Td>
          <Text size="sm">{u.fullName ?? "—"}</Text>
        </Td>
        <Td>
          <Group gap={4} className="flex-wrap">
            {u.roles.map((r) => (
              <Badge key={r} variant="light" color="info" size="sm">
                {r}
              </Badge>
            ))}
          </Group>
        </Td>
        <Td>
          {u.areas.length === 0 ? (
            <Text size="xs" c="dimmed">
              —
            </Text>
          ) : (
            <Group gap={4} className="flex-wrap">
              {u.areas.map((a) => (
                <Badge key={a} variant="outline" size="sm" uppercase={false}>
                  {a}
                </Badge>
              ))}
            </Group>
          )}
        </Td>
        <Td>
          {u.organizaciones.length === 0 ? (
            <Text size="xs" c="dimmed">
              Todas (admin/auditor)
            </Text>
          ) : (
            <Group gap={4} className="flex-wrap">
              {u.organizaciones.map((o) => (
                <Badge key={o.id} variant="light" color="exito" size="sm" title={`Sociedad SAP ${o.numeroSociedad}`}>
                  {o.nombre} <span className="font-mono normal-case">{o.numeroSociedad}</span>
                </Badge>
              ))}
            </Group>
          )}
        </Td>
        <Td>
          <Badge variant="light" color={u.activo ? "exito" : "ambar"}>
            {u.activo ? "Activo" : "Bloqueado"}
          </Badge>
        </Td>
        <Td align="right">
          <Button
            variant={expandida ? "filled" : "default"}
            size="xs"
            leftSection={expandida ? <IconX size={12} /> : undefined}
            onClick={onToggle}
          >
            {expandida ? "Cerrar" : "Editar"}
          </Button>
        </Td>
      </Tr>
      {expandida ? (
        <Tr className="bg-muted/40">
          <Td colSpan={7}>
            <PanelEdicionUsuario u={u} todasAreas={todasAreas} todasOrganizaciones={todasOrganizaciones} />
          </Td>
        </Tr>
      ) : null}
    </>
  );
}
